import React from 'react';
import {IconProps} from './typing';

const Reload = ({iconSize}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={iconSize}
    height={iconSize}
    viewBox="0 0 12 12"
  >
    <path
      fill="currentColor"
      fillRule="nonzero"
      d="M8.86 2.744l-.737 1.108c.997.69 1.575 1.838 1.535 3.05.045.983-.325 1.94-1.022 2.636-.696.697-1.653 1.067-2.636 1.022-.983.045-1.94-.325-2.636-1.022-.697-.696-1.067-1.653-1.022-2.636-.086-1.768 1.173-3.316 2.92-3.592-.263.303-.583.653-.96 1.035l.947.934C5.907 4.613 7.432 3 7.38 2.442c-.038-.456-.957-1.23-2.732-2.303L3.96 1.278c.46.277.822.515 1.12.72-2.405.364-4.155 2.473-4.068 4.904-.046 1.336.465 2.632 1.41 3.578.946.945 2.241 1.456 3.578 1.41 1.337.046 2.632-.465 3.578-1.41.945-.946 1.456-2.242 1.41-3.578.044-1.658-.758-3.224-2.129-4.157z"
    />
  </svg>
);

export default Reload;
